<div class="menu-wrapper">
  @for (item of items; track $index) {
    <mat-checkbox [checked]="isChecked(item)"
                  (change)="check($event, item)"
                  (click)="$event.stopPropagation()"
                  class=""
    >
      {{ item.givenName }} {{ item.familyName }}
    </mat-checkbox>
  }

  <div class="menu-footer">
    <mat-divider></mat-divider>

    <div class="menu-footer-actions">
      <button
        mat-button
        color="accent"
        (click)="setFilter([])">
        Clear
      </button>
      <button
        mat-button
        color="accent"
        (click)="apply()">
        Apply
      </button>
    </div>
  </div>
</div>
